import * as React from 'react';
import emptyImage from 'src/assets/emptyInvoicesImage';

import './EmptyCredits.scss';

class EmptyCredits extends React.Component<any, any> {
  public render() {
    return (
      <div className="rp-empty-credits row">
        <div className="col-12 d-flex justify-content-center align-items-end">
          <img src={emptyImage} className="img-fluid" />
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <h1 className="rp-empty-credits-title">
            You Have No Credits To Manage
          </h1>
        </div>
      </div>
    );
  }
}

export default EmptyCredits;
